import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const RepublicSeedrsLogoCompactIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
    width="72px"
    height="24px"
    viewBox="0 0 72 24"
  >
    <g id="Default+Dark">
      <g id="Seedrs Logo">
        <path
          id="Fill 8"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.6876 8.79997C53.8297 5.70004 66.7855 3.65115 67.887 3.4813C63.1356 -1.17085 55.4621 -1.16109 50.7262 3.51466C46.4162 7.76897 46.0312 14.4137 49.5426 19.1119C47.4729 15.9051 47.8505 11.601 50.6876 8.79997Z"
          fill="#BCD672"
        />
        <path
          id="Fill 9"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67.9581 3.55078C67.7868 4.63809 65.7123 17.4289 62.5711 20.5285C59.7321 23.3314 55.3696 23.7032 52.1189 21.6571C56.8793 25.1259 63.614 24.7469 67.9246 20.4919C72.6632 15.8153 72.6728 8.24223 67.9581 3.55078Z"
          fill="#6B8F3E"
        />
        <path
          id="Fill 11"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64.0793 16.7646C61.5476 19.2635 57.3536 19.1722 54.7083 16.5607C52.0629 13.9509 51.9705 9.80957 54.5014 7.31095C55.093 6.72743 56.1503 6.2032 57.4197 5.74219C54.5459 6.57638 51.8928 7.61022 50.6875 8.79986C47.4075 12.0394 47.4075 17.2906 50.6875 20.5282C53.9695 23.7674 59.2892 23.7677 62.5709 20.5282C63.7758 19.3395 64.8222 16.7239 65.6663 13.8905C65.2004 15.1402 64.6705 16.1814 64.0793 16.7646Z"
          fill="#8AC144"
        />
      </g>
      <path
        id="Stroke"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.9302 23.9997L33.9302 3.61745e-08L34.7578 0L34.7578 23.9997L33.9302 23.9997Z"
        fill="#DFE3E8"
      />
      <g id="Republic">
        <path
          id="Vector"
          d="M12.2353 0.0481432C15.6222 0.303202 18.3671 2.94501 18.8066 6.37271C19.2462 9.80042 17.2595 13.0709 14.0504 14.2022L21.228 23.9994H0.0263672V0H11.1652C11.5554 0 11.9101 0.0180537 12.2353 0.0481432Z"
          fill="#157EFF"
        />
        <path
          id="Vector_2"
          d="M13.8228 23.9992H0V0L21.0775 23.9992H13.8228Z"
          fill="#157EFF"
        />
        <path
          id="Vector_3"
          d="M21.2255 23.9998H0L10.5414 7.24023L21.2255 23.9998Z"
          fill="#00BDFF"
        />
        <path
          id="Vector_4"
          d="M0 13.8891V0H5.92405L14.7748 13.883L0 13.8891Z"
          fill="#1560FA"
        />
        <path
          id="Vector_5"
          d="M6.36133 13.8896L10.5414 7.24023L14.7807 13.8896H6.36133Z"
          fill="#00EFE9"
        />
        <path
          id="Vector_6"
          d="M21.225 23.9998H13.3377L10.541 7.24023L21.225 23.9998Z"
          fill="#157EFF"
          fillOpacity="0.5"
        />
      </g>
    </g>
  </ChakraIcon>
);
